import React from "react";
import { isMobileOnly, isTablet } from "react-device-detect";

export const DeviceContext = React.createContext();
export const useDevice = () => React.useContext(DeviceContext);

export const DeviceProvider = ({children}) => {
  return (
    <DeviceContext.Provider
      value={{
        isMobileOnly,
        isTablet
      }}
    >
      {children}
    </DeviceContext.Provider>
  );
};